<h4>Simulation Settings <span class="closing-btn" (click)="close()">X</span></h4>

<form [formGroup]="channel" class="temp-mamagement-custom-settings">
  <span class="small-tile-inside mb-2">{{data?.simulationData?.name}}</span>
  <div class="mt-3">
    <mat-form-field appearance="outline" class="temp-settings-name-input">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_NAME_LABEL }}</mat-label>
      <input matInput type="text" formControlName='name' [maxLength]="templateConfig?.fieldLengthLimit?.attributeName"
        (input)="inputValidator($event)">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_DESCRIPTION_LABEL }}</mat-label>
      <textarea matInput [maxLength]="templateConfig?.fieldLengthLimit?.attributeDescription"
        formControlName='description' (input)="inputValidator($event)"></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="h-fc">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_TYPE_LABEL }}</mat-label>
      <mat-select formControlName="type" disableOptionCentering>
        <mat-option value="CONSTANT">Constant</mat-option>
        <mat-option value="RANDOM">Random</mat-option>
        <mat-option value="ORDERED">Ordered</mat-option>
        <mat-option value="TIMESERIES">Time Series</mat-option>
        <mat-option value="TIMESTAMP">Time Stamp</mat-option>
        <mat-option value="DEVICEINFO">Device Info</mat-option>
        <mat-option value="UNIQUEID">Unique Id</mat-option>
        <mat-option value="CSV" [disabled]="!data?.fileUploaded">From CSV</mat-option>
      </mat-select>
      <mat-error *ngIf="channel.get('type')?.hasError('required')">
        <strong>{{ MESSAGES?.TEMPLATE_FORM_TYPE_LABEL }}</strong> {{ MESSAGES?.MESSAGE_REQUIRED }}
      </mat-error>
    </mat-form-field>
  </div>

  <h4 class="mb-2 mt-2" *ngIf="channel.get('type')?.value"> Field Configuration </h4>

  <div>
    <mat-form-field *ngIf="channel.get('type')?.value ==='TIMESTAMP'" appearance="outline">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_TIME_ZONE_LABEL }}</mat-label>
      <mat-select formControlName="timeZone" disableOptionCentering>
        <mat-option *ngFor="let timeZone of timeZoneNames" [value]="timeZone.toLowerCase()">
          {{ timeZone }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="channel.get('type')?.value ==='TIMESTAMP'" appearance="outline">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_FORMAT_LABEL }}</mat-label>
      <mat-select formControlName="format" disableOptionCentering>
        <mat-option *ngFor="let format of formatList" [value]="format?.value">
          {{ format?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="channel.get('type')?.value ==='DEVICEINFO'" appearance="outline">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_FIELD_TO_CHANGE_LABEL }}</mat-label>
      <mat-select formControlName="deviceField" disableOptionCentering>
        <mat-option *ngFor="let field of deviceFieldList" [value]="field?.value">
          {{ field?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="channel.get('type')?.value ==='UNIQUEID'" class="field-error-style">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_FIELD_LENGTH_LABEL }}</mat-label>
        <input matInput type="number" min="15" max="100" formControlName="fieldLength" (paste)="(false)" (keypress)="numberOnly($event)">
      </mat-form-field>
      <mat-error class="ml-10" *ngIf="channel.get('fieldLength')?.value && channel.get('fieldLength')?.value < fieldLengthLimit?.fieldLengthMin">
        <strong> Minimum value is {{ fieldLengthLimit?.fieldLengthMin }}</strong>
      </mat-error>
      <mat-error class="ml-10" *ngIf="channel.get('fieldLength')?.value && channel.get('fieldLength')?.value > fieldLengthLimit?.fieldLengthMax">
        <strong>Maximum value is {{ fieldLengthLimit?.fieldLengthMax }}</strong>
      </mat-error>
    </div>

    <mat-form-field *ngIf="channel.get('type')?.value ==='CSV'" appearance="outline">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_SELECT_HEADER_LABEL }}</mat-label>
      <mat-select formControlName="columnName" disableOptionCentering>
        <mat-option *ngFor="let item of data?.headerData" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_TREND_SLOPE_LABEL }}</mat-label>
        <input matInput type="number" formControlName="trendSlope"
          (keypress)="numberOnly($event,'exponent',channel.get('trendSlope')?.value)">
      </mat-form-field>
    </div>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_SEASONALITY_AMPLITUDE_LABEL }}</mat-label>
        <input matInput type="number" formControlName="seasonalityAmplitude"
          (keypress)="numberOnly($event,'exponent',channel.get('seasonalityAmplitude')?.value)">
      </mat-form-field>
    </div>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_INITIAL_VALUE_LABEL }}</mat-label>
        <input matInput type="number" formControlName="initialValue"
          (keypress)="numberOnly($event,'exponent',channel.get('initialValue')?.value)">
      </mat-form-field>
    </div>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_NOISE_LEVEL_LABEL }}</mat-label>
        <input matInput type="number" formControlName="noiseLevel" (keypress)="numberOnly($event,'nonNegative')">
      </mat-form-field>
    </div>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_TREND_NOISE_LEVEL_LABEL }}</mat-label>
        <input matInput type="number" formControlName="trendNoiseLevel" (keypress)="numberOnly($event,'nonNegative')">
      </mat-form-field>
    </div>
    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_LOWER_THRESHOLD_LABEL }}</mat-label>
        <input matInput type="number" formControlName="lowerThreshold"
          (keypress)="numberOnly($event,'exponent',channel.get('lowerThreshold')?.value)">
      </mat-form-field>
    </div>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_UPPER_THRESHOLD_LABEL }}</mat-label>
        <input matInput type="number" formControlName="upperThreshold"
          (keypress)="numberOnly($event,'exponent',channel.get('upperThreshold')?.value)">
      </mat-form-field>
    </div>

    <div *ngIf="channel.get('type')?.value ==='TIMESERIES'" class="field-error-style">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_NO_OF_DECIMALS_LABEL }}</mat-label>
        <input matInput type="number" max="16" formControlName="noOfDecimals" (keypress)="numberOnly($event)"
          autocomplete="disabled" (paste)="(false)">
      </mat-form-field>
      <mat-error class="ml-10" *ngIf="channel.get('noOfDecimals')?.value > 16">
        <strong>Value</strong> must be less than 16
      </mat-error>
    </div>

    <mat-form-field appearance="outline"
      *ngIf="channel.get('type')?.value ==='RANDOM' || channel.get('type')?.value ==='ORDERED'">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_START_VALUE_LABEL }}</mat-label>
      <input matInput type="number" formControlName="startValue">
    </mat-form-field>

    <mat-form-field appearance="outline"
      *ngIf="channel.get('type')?.value ==='RANDOM' || channel.get('type')?.value ==='ORDERED'">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_END_VALUE_LABEL }}</mat-label>
      <input matInput type="number" formControlName="endValue">
    </mat-form-field>

    <div *ngIf="channel.get('type')?.value ==='ORDERED'" class="field-error-style">
      <mat-form-field appearance="outline">
        <mat-label>{{ MESSAGES?.TEMPLATE_FORM_STEP_VALUE_LABEL }}</mat-label>
        <input matInput type="number" formControlName="stepValue">
      </mat-form-field>
      <mat-error *ngIf="channel.get('stepValue')?.hasError('invalidStep')">
        {{ channel.get('stepValue')?.errors?.['message'] }}
      </mat-error>
    </div>

    <mat-form-field *ngIf="channel.get('type')?.value ==='CONSTANT'" appearance="outline">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_INPUT_VALUE_LABEL }}</mat-label>
      <input (input)="inputValidator($event,'inputValue')" matInput formControlName="inputValue">
    </mat-form-field>
  </div>
  <div class="mt-3">
    <mat-form-field appearance="outline"
      *ngIf="channel.get('type')?.value && (channel.get('type')?.value ==='CSV' || channel.get('type')?.value ==='ORDERED')">
      <mat-label>{{ MESSAGES?.TEMPLATE_FORM_BEHAVIOUR_AFTER_LAST_VALUE_LABEL }}</mat-label>
      <mat-select formControlName="behaviour" disableOptionCentering>
        <mat-option *ngFor="let item of behaviourList" [value]="item?.value">
          {{ item?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox class="checkbox" *ngIf="channel.get('type')?.value ==='RANDOM' " formControlName="cumulative">
      {{ MESSAGES?.TEMPLATE_FORM_CUMULATIVE_LABEL }}</mat-checkbox>
    <mat-checkbox class="checkbox"
      *ngIf="(channel.get('type')?.value ==='RANDOM' && channel.get('cumulative')?.value) || (channel.get('type')?.value ==='ORDERED')"
      formControlName="carryForward">{{ MESSAGES?.TEMPLATE_FORM_CARRY_FORWARD_LABEL }}</mat-checkbox>
  </div>
</form>
<div class="the-button-set">
  <button (click)="close()">Cancel</button>
  <button class="select" (click)="close('submit')" [disabled]="!channel?.valid || !channel?.dirty"> {{ data?.pageType
    === 'Device-Attach' ? 'Update' : 'Done' }}</button>
</div>